module.exports = __webpack_public_path__ + "static/media/fundo.50e70faf.png";